// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-46b82220]{background-color:rgba(0,0,0,.5)}.close[data-v-46b82220]{top:14px;right:20px}.modal-loading-indicator[data-v-46b82220]{background:50%/50px no-repeat url(/wp-content/themes/snappy-theme/assets/images/loading2.gif);height:50px;width:50px;margin:0 auto}button[data-v-46b82220]:hover{background-color:unset}iframe[data-v-46b82220]{border:0;height:80vh;width:100%}", ""]);
// Exports
module.exports = exports;
